import React from "react";
import { Dialog, Transition } from "@headlessui/react";
import { Fragment } from "react";
import { useTranslation } from "react-i18next";

export default function PaymentFailedModal({
  modalHeading,
  modalMessage,
  modalIcon,
  isOpen,
  closeModal,
  paymentId,
}) {
  const { t } = useTranslation();

  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog as="div" className="relative z-10" onClose={closeModal}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black bg-opacity-25" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel id="payment-failed-modal" className="relative w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 shadow-xl transition-all">
                <button
                  id="payment-failed-modal-close-button"
                  type="button"
                  className="absolute top-1 right-3 focus:outline-none text-2xl text-gray-400 hover:text-gray-600"
                  onClick={closeModal}
                >
                  <span className="sr-only">Close</span>
                  &times;
                </button>
                <Dialog.Title
                  as="h3"
                  className={`flex flex-col gap-2 text-lg items-center w-full font-bold leading-6 ${
                    modalHeading === "Payment Pending !"
                      ? "text-[#DC6803]"
                      : "text-[#D92D20]"
                  }`}
                >
                  <img src={modalIcon} alt="" />
                  <div>{modalHeading}</div>
                </Dialog.Title>
                <div className="mt-2 flex flex-col">
                  <p id="payment-failed-modal-message-description" className="text-md font-semibold text-gray-900">
                    {modalMessage}
                  </p>
                  <p className="text-center mt-2 text-md font-semibold text-gray-600">
                    {t("verify:payment_id")} {paymentId}
                  </p>
                </div>
                <div className="mt-3">
                  <button
                    id="payment-failed-modal-dismiss-button"
                    type="button"
                    className="bg-cfButton text-white text-sm font-semibold px-[2rem] py-2 rounded-lg"
                    onClick={closeModal}
                  >
                    {t("verify:close")}
                  </button>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
}
